import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    prohibitedAction: [],
    prohibitedPages: [],
    trackingEventDataSetting: {},
    systemAuId: ''
  },
  getters: {
    getProhibitedAction (state) {
      return state.prohibitedAction
    },
    getProhibitedPages (state) {
      return state.prohibitedPages
    },
    isProhibitedDeposit (state) {
      return state.prohibitedAction.indexOf('deposit') > -1
    },
    isProhibitedPrepaid (state) {
      return state.prohibitedAction.indexOf('prepaid') > -1
    },
    isProhibitedSmbc (state) {
      return state.prohibitedAction.indexOf('smbc') > -1
    },
    isProhibitedGelato (state) {
      return state.prohibitedAction.indexOf('gelato') > -1
    },
    isProhibitedSeven (state) {
      return state.prohibitedAction.indexOf('seven') > -1
    },
    isProhibitedWakai (state) {
      return state.prohibitedAction.indexOf('wakai') > -1
    },
    getTrackingEventDataSetting (state) {
      return state.trackingEventDataSetting
    },
    getSystemAuId (state) {
      return state.systemAuId
    }
  },
  mutations: {
    setProhibitedAction (state, prohibitedAction) {
      state.prohibitedAction = prohibitedAction
    },
    setProhibitedPages (state, prohibitedPages) {
      state.prohibitedPages = prohibitedPages
    },
    setTrackingEventDataSetting (state, trackingEventDataSetting) {
      state.trackingEventDataSetting = trackingEventDataSetting
    },
    setSystemAuId (state, systemAuId) {
      state.systemAuId = systemAuId
    }
  },
  actions: {
    setProhibitedAction ({commit}, prohibitedAction) {
      commit('setProhibitedAction', prohibitedAction)
    },
    setProhibitedPages ({commit}, prohibitedPages) {
      commit('setProhibitedPages', prohibitedPages)
    },
    setTrackingEventDataSetting ({commit}, trackingEventDataSetting) {
      commit('setTrackingEventDataSetting', trackingEventDataSetting)
    },
    setSystemAuId ({commit}, systemAuId) {
      commit('setSystemAuId', systemAuId)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js